import React, {Component} from "react";
import '../Subjective.css';
import '../../EMR.css';
import './ComplaintView.css';
import YesNoNotAvailableEnum from "../../../../genericenums/YesNoNotAvailableEnum";
import {Grid} from "@material-ui/core";

export default class BirthHistoryView extends Component {

    render() {
        let divs = this.getDivs();
        return (
            <Grid container alignItems={"center"} className={"content-card content-row m-0 w-100 p-2"}>
                <Grid item xs style={{maxWidth: 200}} className={"content-card-title"}>
                    <h6 className={"no-margin"}>Birth History</h6>
                </Grid>
                <Grid item xs>
                    <div className="p-2 pl-3" style={{borderLeft: "1px gainsboro solid"}}>
                        {(divs != null && divs.length != 0) ? divs :
                            <div>
                                No information
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
        );
    }

    getDivs() {
        if (this.props.birthHistory == null) {
            return null;
        }
        let divs = [];

        if (this.props.birthHistory.currentlyPregnant != null) {
            divs.push(
                <div key={"birthHistoryViewDivPregnant"}>
                    Currently
                    Pregnant: {YesNoNotAvailableEnum[this.props.birthHistory.currentlyPregnant].name}{this.props.birthHistory.currentlyPregnantDetail == null ? '' : (", " + this.props.birthHistory.currentlyPregnantDetail)}
                </div>);
        }

        return divs;
    }
}